/*@flow*/
// import { createElement } from 'react';
// import * as I from 'immutable';
// import type { ComponentPropsT } from '../types';
// import getTemplate from '../util/getTemplate';
// import { getDefaultLabel } from '../util';
// import getTransformer from '../util/getTransformer';
// import { useLocals, useField } from '../hooks';

export default function CheckboxGroupComponent(): null {
  return null;
}
